import { render } from "./TurnamenSayaPage.vue?vue&type=template&id=16d75a7d&scoped=true"
import script from "./TurnamenSayaPage.vue?vue&type=script&lang=js"
export * from "./TurnamenSayaPage.vue?vue&type=script&lang=js"

import "./TurnamenSayaPage.vue?vue&type=style&index=0&id=16d75a7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d75a7d"]])

export default __exports__